import { render, staticRenderFns } from "./dialog-replace-hydropower.vue?vue&type=template&id=589f37e1&scoped=true&"
import script from "./dialog-replace-hydropower.vue?vue&type=script&lang=js&"
export * from "./dialog-replace-hydropower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f37e1",
  null
  
)

export default component.exports